import styled from '@emotion/styled';


export const RangeFieldWrapper = styled.div<{ fullWidth: boolean }>`
  ${({ fullWidth }) => `
    display: flex;
    align-items: baseline;
    width: 100%;
    ${fullWidth ? `
      > div:last-of-type,
      > div:first-of-type {
        width: 100%;
        button {
          width: 100%;
        }
      }
    ` : ''}
  `}
`;

export const RangeFieldDivider = styled.div`
  ${({ theme }) => `
    display: flex;
    margin: 0 ${theme.spacing(1)};
  `}
`;

export const BlackDivider = styled.div`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  margin: 0 ${({ theme }) => theme.spacing(0.5)};
  position: relative;
  align-self: center;
  &:after {
    content: '';
    position: absolute;
    width: 9px;
    height: 2px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: ${({ theme }) => theme.colors.neutrals.grey1};
    border-radius: ${({ theme }) => theme.borderRadius.small};
  }
`;
